// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".-YTqpk14Ch39ZZ0zA-E5G {\n  display: flex;\n  align-items: center;\n  padding:11px;\n  cursor: pointer;\n  height:36px;\n}\n\n._1Po_V3mDfC7Clu2wy10woH {\n  background-color:rgba(47,181,199, 0.2);\n  border-radius: 4px;\n}\n\n._1nMDEBWsotyQig9rg4Sz9e {\n  border:1px solid rgb(47,181,199);\n}\n\n._1FoHC_Uh7888QJ0DFuTYu3 {\n  background-color:rgba(163, 3, 10, 0.4);\n  border-radius: 4px;\n}\n._2zwYXYpgLQofxSACC8cDj- {\n  background-color:rgba(163, 3, 10, 0.2);\n  border-radius: 4px;\n}\n\n._2zSQ26u0bMB_8E45Vk7EeY {\n  margin-left:10px;\n  color: #32445A;\n  font-family: \"Open Sans\";\n  font-size: 13px;\n  font-weight: bold;\n  letter-spacing: 0;\n  line-height: 18px;\n  display: flex;\n  flex-grow: 1;\n  justify-content: space-between;\n}\n\n._2HBF8djmfZfWsbPMcku33O {\n  background: #32445A !important;\n}\n\n._3uRsEMxxfi8zXIbYQqEKrS {\n  background: #C7C7C7;\n}\n", ""]);
// Exports
exports.locals = {
	"tabSwitch": "-YTqpk14Ch39ZZ0zA-E5G",
	"tabSwitchActive": "_1Po_V3mDfC7Clu2wy10woH",
	"tabSwitchActiveBorder": "_1nMDEBWsotyQig9rg4Sz9e",
	"tabSwitchActiveHasError": "_1FoHC_Uh7888QJ0DFuTYu3",
	"tabSwitchHasError": "_2zwYXYpgLQofxSACC8cDj-",
	"tabLabel": "_2zSQ26u0bMB_8E45Vk7EeY",
	"actionSwitchOn": "_2HBF8djmfZfWsbPMcku33O",
	"actionSwitchOff": "_3uRsEMxxfi8zXIbYQqEKrS"
};
module.exports = exports;
